export default "__VITE_ASSET__CXOVxBRC__"